import { render, staticRenderFns } from "./supervisorReply.vue?vue&type=template&id=6b3d4060"
import script from "./supervisorReply.vue?vue&type=script&lang=js"
export * from "./supervisorReply.vue?vue&type=script&lang=js"
import style0 from "./supervisorReply.vue?vue&type=style&index=0&id=6b3d4060&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports